<template>
  <div id="page-user-view">

    <div id="user-data" v-if="userInfo">

      <vx-card :title="$t('userView.userInfomation')" class="mb-base text-size ">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Avatar Col -->
          <div class="vx-col cursor-pointer" id="avatar-col">
            <div class="img-container mb-4">
              <img v-if="userInfo.img"  @error="imgError"  :src="userInfo.img" class="rounded w-full" @click="openDialog"/>
              <img v-else :src="userInfo.avatar" class="rounded w-full" @click="openDialog"/>
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{$t('userView.email')}}</td>
                <td>{{ userInfo.email }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{$t('userView.userName')}}</td>
                <td>{{ userInfo.fullName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{$t('userView.phoneNumber')}}</td>
                <td>{{ userInfo.phoneNumber }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">{{$t('userView.organization')}}</td>
                <td>{{ userInfo.organization ? userInfo.organization.organizationName : '' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{$t('userView.birthDate')}}</td>
                <td>{{ userInfo.birthday | formatDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{$t('userView.address')}}</td>
                <td>{{ userInfo.fullAddress }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="vx-col flex-2" id="account-info-col-2">
          <div class="vx-row">
            <vs-button class="text-size" @click="editUser">{{$t('userView.edit')}}</vs-button>
            <vs-button class = "ml-6 text-size" @click="changePassword">{{$t('userView.changePassword')}}</vs-button>
            <vs-switch class="mt-4  ml-4" v-model="acceptNotify" @click="acceptNotifycation"></vs-switch>
            <span class="mt-5 ml-4">{{$t('userView.registerNotify')}}</span>
            <!-- <vs-switch class="mt-4  ml-4" v-model="reduced_dasboard" @click="getValueSwitch"/>
            <span class="mt-4 ml-4">Menu điều hướng</span> -->
          </div>
        </div>
      </vx-card>

      <div class="vx-row" v-if="false">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Thông tin gói cước" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Tên gói</td>
                <td>{{ usingPackage.businessPackage ? usingPackage.businessPackage.name : '' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Ngày bắt đầu</td>
                <td>{{ usingPackage.startDate | formatDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Ngày kết thúc</td>
                <td>{{ usingPackage.expiredDate | formatDate }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>

    </div>
    <vs-popup title="Cập nhật ảnh đại diện" :active.sync ="activePopup">
      <div class="vx-row">
        <div class="vx-col mt-2 w-full">
          <vs-upload
              style="padding-left:11rem"
              id="fileInput"
              label ="Ảnh đính kèm"
              accept="image/jpeg"
              automatic
              @on-success="successUpload"
              @change="onFileChange"
              @on-error="errorMessage"
              v-model="form.image"
              :show-upload-button="showUpload"
              :single-upload="true"
              :limit="1"
              >
          </vs-upload>
        </div>
      </div>
      <div class="vx-row mt-4 text-size">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2 border-radius" icon-pack="feather" @click="activePopup = false" icon="icon" type="border">Quay lại
                </vs-button>
                <vs-button class="ml-4 mt-2 border-radius" icon-pack="feather" icon="icon" @click="saveImage"> Cập nhật
                </vs-button>
              </div>
            </div>
          </div>
    </vs-popup>
    <my-upload
        field="img"
        v-model="showUploadImage"
        @crop-success="cropSuccess"
        :width="300"
        :height="300"
        img-format="png"
        :langExt  ="vn"
    >

    </my-upload>
  </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload'
import NoImage from '@/assets/images/portrait/small/user-avatar.png';
  export default {
    components:{
      'my-upload':myUpload
    },
    data() {
      return {
        userInfo: {
          enabled: 'Hoạt động',
          avatar: require("@/assets/images/portrait/small/user-avatar.png"),
          img:null
        },
        usingPackage: {

        },
        activePopup:false,
        form:{
          image:null
        },
        reduced_dasboard:false,
        showUpload:false,
        vn: {
          hint: 'Chọn ảnh cập nhật',
          loading: 'Đang cập nhật...',
          noSupported: 'Trình duyệt không hỗ trợ',
          primary: 'Cập nhật thành công',
          fail: 'Cập nhật thất bại',
          preview: 'Xem trước',
          btn: {
              off: 'Hủy',
              close: 'Đóng',
              back: 'Quay lại',
              save: 'Cập nhật'
          },
          error: {
              onlyImg: 'Chỉ được đăng tải định dạng là ảnh',
              outOfSize: 'Ảnh tải lên vượt quá dung lượng cho phép',
              lowestPx: 'Ảnh tải lên dung lượng quá thấp.'
          }
        },
        showUploadImage: false,
        acceptNotify: false,
        user: {
          gender: null,
          city: null,
          district: null,
          subDistrict: null,
          address: null,
          houseNumber: null,
          password: "",
          rePassword: "",
          activeStatus: 0
        }
      }
    },
    methods: {
      imgError(image) {
        image.target.src = NoImage;
      },
      acceptNotifycation: function(){
        const payloadUser = {
          fullName: this.user.fullName,
          email: this.user.email,
          phoneNumber: this.user.phoneNumber,
          gender: this.user.gender,
          birthday: this.user.birthday,
          organizationName: this.user.organizationName,
          city: this.user.city,
          district: this.user.district,
          subDistrict: this.user.subDistrict,
          houseNumber: this.user.houseNumber,
          fullAddress: this.user.fullAddress,
          password: this.user.password,
          firstLogin: 1,
          allowNotify: this.acceptNotify ? 0 : 1
        }
        this.$vs.loading();
        this.$oauth.post('/user/update-info', payloadUser).then(() => {
            this.$vs.loading.close();
        })
      },
      editUser() {
        this.$router.push(`/user/user-edit`).catch(() => {
        });
      },
      changePassword() {
        this.$router.push(`/user/change-password`).catch(() => {
        });
      },
      getValueSwitch:function(){
        if(this.reduced_dasboard == true){
        const  mainLayoutType = localStorage.setItem('mainLayoutType','horizontal');
      }
      else{
        const  mainLayoutType = localStorage.setItem('mainLayoutType','vertical');
      }
        location.reload();
      },
      cropSuccess: function(e, fileInput){
        this.fileData = e;
        this.saveImage();
      },
      openDialog: function(){
      // this.activePopup = true;
        this.showUploadImage = true;
      },
      onFileChange: function(e, fileInput){
      if(fileInput){
        this.getBase64(fileInput[0]).then((rs) => {
        this.fileData = rs;
      })
      }
    },
    removeElementsByClass(classname){
      let elements = document.getElementsByClassName(classname);
      while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
          if ((encoded.length % 4) > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4));
          }
          resolve(encoded);
        };
        reader.onerror = error => reject(error);
      });
    },
      saveImage: function(){
      if(!this.fileData){
        return this.$vs.notify({
          text:'Bạn chưa chọn ảnh đại diện',
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }
      this.$vs.loading();
      const data = localStorage.getItem('userInfo');
      const info = JSON.parse(data);
      const base64 = this.fileData;
      const payload ={
        userId:info.id,
        image:base64
      }
      this.$oauth.post(`/user/upload-image`,payload).then((res) =>{
        const response = res.data;
        this.userInfo.img = response.domain;
        this.$vs.loading.close();
        this.activePopup = false;
        const data = localStorage.getItem('userInfo');
        const info = JSON.parse(data);
        if(info.img){
            info.img = response.domain;
            localStorage.setItem('userInfo', JSON.stringify(info));
        }
        location.reload();
      })
      .catch((err)=>{
        this.activePopup = false;
        this.$vs.loading.close();
        return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
    },
      successUpload: function(){
        this.$vs.notify({
          color:'primary',
          title:'Upload success',
          text:"Upload Image suc"
        })
      },
      errorMessage: function(){
        if ( this.fileData) {
          document.getElementsByClassName("con-input-upload")[0].classList.add("con-input-upload-success")
          return 1;
        }
        document.getElementsByClassName("con-input-upload")[0].classList.remove("con-input-upload-success")
      }
    },

    watch: {
      '$store.state.userInformation'(val) {
        this.userInfo = Object.assign({}, this.userInfo, val);
      }
    },

    created() {
      this.$oauth.get('user/current').then((res) => {
        const user = res.data;
        this.user = Object.assign({}, this.user, user);
        if(user && user.allowNotify == 1){
          this.acceptNotify = true;
        }
      })
      this.userInfo = Object.assign({}, this.$store.state.userInformation, this.userInfo);
      this.$vs.loading();
      this.$business.post('/user-package/using-package').then((response) => {
        this.$vs.loading.close();
        this.usingPackage = response.data;
      }).catch(() => {
        this.showPopup = false;
        this.$vs.loading.close();
      });
      const mainLayoutType = localStorage.getItem('mainLayoutType');
      if(mainLayoutType == 'horizontal' || !mainLayoutType){
        this.reduced_dasboard == false;
      }
      else{
        this.reduced_dasboard =true
      }

      const data = localStorage.getItem('userInfo');
      const info = JSON.parse(data);
      if(info.img){
        this.userInfo.img = info.img;
      }
    }
  }

</script>

<style lang="scss">
  #avatar-col {
    width: 10rem;
  }

  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .8rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }

  }
.vicp-operate a{
  color: white !important;
  background-color: #277df6;
  border-radius: 20px;
}
.vicp-operate a:hover{
  color: white !important;
  background-color: #277df6 !important;
  border-radius: 20px !important;
}
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
#page-user-view{
  margin-top: -24px !important;
}
@media only screen and (max-width:600px){
  .vue-image-crop-upload .vicp-wrap {
    width: auto;
    height: auto;
  }
  .vicp-drop-area {
    margin-top: 50px;
  }
  .vicp-step2 .vicp-crop {
    margin-top: 50px;
  }
}
</style>
